module.exports = __webpack_public_path__ + "6c08ef47ae8e014dcb965af32c49ab13.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/unimpressed-2.png
// module id = 2352
// module chunks = 0